const AUTO_RECEIPT_TYPES = new Set([
  "AUTO_RECONCILIATION", "ADVANCE_REFUND", "PARTNER_REFUND", "OTHER_AUTO",
]);

const AUTO_PAYMENT_TYPES = new Set([
  "AUTO_RECONCILIATION", "SALARY", "ADVANCE", "ADVANCE_SUPPLEMENT", "PREPAID", "CUSTOMER_REFUND", "ALLOCATION",
]);

export const isAutoReceiptType = (type) => AUTO_RECEIPT_TYPES.has((type || "").trim().toUpperCase());

export const isAutoPaymentType = (type) => AUTO_PAYMENT_TYPES.has((type || "").trim().toUpperCase());

export const formatCategoryLabel = (voucherType, categoryName, isReceipt = true) => {
  const isAuto = isReceipt ? isAutoReceiptType(voucherType) : isAutoPaymentType(voucherType);
  const prefix = isAuto ? "[AUTO]" : "[MAN]";
  const name = categoryName || "—";
  return `${prefix} ${name}`;
};
